// This file contains helper functions for the Film Development Wizard

// Helper function to get available processing types based on film type
function getAvailableProcessingTypes(filmType) {
  console.log("Getting available processing types for:", filmType);
  
  // Make sure filmType is defined before proceeding
  if (!filmType) {
    console.error("Film type is undefined in getAvailableProcessingTypes");
    return ["Color (C-41)", "Black-and-White"]; // Default fallback
  }
  
  // Normalize film type string to handle any case or whitespace variations
  const normalizedFilmType = filmType.trim();
  
  switch(normalizedFilmType) {
    case "35mm":
      return ["Color (C-41)", "Black-and-White", "E-6 (Slide Film)", "Cross Processing", "ECN-2 (Cinematic Film)"];
    case "Disposable Camera":
      return ["Color (C-41)", "Black-and-White"];
    case "120":
      // 120 film only supports these three processing types
      // E-6 and ECN-2 are intentionally excluded as per requirements
      console.log("120 film selected - returning limited processing options");
      return ["Color (C-41)", "Black-and-White", "Cross Processing"];
    case "110":
    case "APS":
      return ["Color (C-41)", "Black-and-White"];
    default:
      console.warn(`Unknown film type "${normalizedFilmType}", falling back to default options`);
      return ["Color (C-41)", "Black-and-White", "E-6 (Slide Film)", "Cross Processing", "ECN-2 (Cinematic Film)"];
  }
}

// Helper function to check if a resolution step is needed for the film type
function shouldShowResolutionStep(filmType) {
  return filmType === "35mm" || filmType === "Disposable Camera" || filmType === "120";
}

// Helper function to build a variant key from selections
function buildVariantKey(filmType, processingType, scanMethod, resolution) {
  if (!processingType) return '';
  
  console.log(`Building variant key for: filmType=${filmType}, processingType=${processingType}, scanMethod=${scanMethod}, resolution=${resolution}`);
  
  // Normalize inputs to match variant mapping format
  // Extract the base processing type and handle special cases
  let baseProcessingType;
  
  // For C-41, we need to keep the C-41 part for ALL film types now
  if (processingType.includes('C-41')) {
    baseProcessingType = 'Color_C-41';
  } else if (processingType.includes('Black-and-White')) {
    baseProcessingType = 'Black-and-White';
  } else if (processingType.includes('E-6')) {
    baseProcessingType = 'E-6_Slide_Film';
  } else if (processingType.includes('ECN-2')) {
    baseProcessingType = 'ECN-2_Cinematic_Film';
  } else if (processingType.includes('Cross Processing')) {
    baseProcessingType = 'Cross_Processing';
  } else {
    // For other processing types, replace special characters with underscores
    baseProcessingType = processingType.replace(/\s+\([^)]+\)/g, '').replace(/\s+/g, '_');
  }
  
  // Get shipping option from step 5
  const shippingOption = userSelections['step5'] || "";
  let shippingKey = "";
  
  if (shippingOption === "Hold Negatives") {
    shippingKey = "Hold_Negs";
  } else if (shippingOption === "Destroy / Bin my Negatives") {
    shippingKey = "Bin_Negs";
  } else if (shippingOption === "Send Negatives Back") {
    // Check if we have a sub-option
    if (userSelections['step5_shipping'] && userSelections['step5_shipping'].includes("items in my cart")) {
      shippingKey = "Send_Negs_back_with_other";
    } else {
      shippingKey = "Send_Negs_back";
    }
  } else if (userSelections['step5_shipping']) {
    // Handle the shipping sub-options directly
    if (userSelections['step5_shipping'].includes("items in my cart")) {
      shippingKey = "Send_Negs_back_with_other";
    } else if (userSelections['step5_shipping'].includes("once processed")) {
      shippingKey = "Send_Negs_back";
    } else if (userSelections['step5_shipping'].includes("all my past")) {
      shippingKey = "Send_Negs_back";
    } else {
      shippingKey = "Send_Negs_back";
    }
  } else {
    // Default to Hold Negs if no shipping option is selected
    shippingKey = "Hold_Negs";
  }
  
  // For 110 and APS, the key format is just baseProcessingType_shippingKey
  if (filmType === "110" || filmType === "APS") {
    const key = `${baseProcessingType}_${shippingKey}`;
    console.log(`Built key for ${filmType}: ${key}`);
    return key;
  }
  // For all other film types (35mm, Disposable Camera, 120), we need to include scan method and resolution
  else {
    // Normalize scan method and resolution with fallbacks
    const normalizedScanMethod = scanMethod ? scanMethod.replace(/\s+/g, '_') : 'Scan_and_Email';
    const normalizedResolution = resolution ? resolution.replace(/\s+/g, '_') : 'Standard_Resolution';
    
    const key = `${baseProcessingType}_${normalizedScanMethod}_${normalizedResolution}_${shippingKey}`;
    console.log(`Built key for ${filmType} film with shipping: ${key}`);
    return key;
  }
}

function updateNavigation() {
  console.log("Updating navigation, current step:", currentStep);
  
  // First remove active class from all circles
  document.querySelectorAll('.step-circle').forEach(circle => {
    circle.classList.remove('active');
  });
  
  // Then add active class to the current step's circle
  let circleToActivate = currentStep;
  
  // Handle sub-steps like 41, 42, 51 by mapping them to their main step
  if (currentStep === 41 || currentStep === 42) {
    circleToActivate = 4;
  } else if (currentStep === 51) {
    circleToActivate = 5;
  }
  
  const currentCircle = document.getElementById(`circle-${circleToActivate}`);
  if (currentCircle) {
    currentCircle.classList.add('active');
    console.log(`Activated circle for step ${circleToActivate}`);
  } else {
    console.error(`Could not find circle element for step ${circleToActivate}`);
  }
  
  // Show or hide back button based on current step
  const backButton = document.getElementById('fixed-back-button');
  if (backButton) {
    if (currentStep > 1) {
      backButton.classList.add('visible');
      backButton.style.display = 'flex';
    } else {
      backButton.classList.remove('visible');
      backButton.style.display = 'none';
    }
  }
  
  // Make sure the first circle is always highlighted when on step 1
  if (currentStep === 1) {
    const firstCircle = document.getElementById('circle-1');
    if (firstCircle && !firstCircle.classList.contains('active')) {
      console.log("Forcing activation of first circle");
      firstCircle.classList.add('active');
    }
  }
}

function updateSidePanel() {
  // Side panel removed - function no longer needed
  return;
}

// Function to get an appropriate shipping label based on selections
function getShippingLabel() {
  if (userSelections['step4'] === 'Yes') {
    return 'Ship with prints';
  }

  if (userSelections['step5_shipping']) {
    if (userSelections['step5_shipping'].includes('once processed')) return 'Ship negs';
    if (userSelections['step5_shipping'].includes('all my past')) return 'Ship all past negs';
    if (userSelections['step5_shipping'].includes('items in my cart')) return 'Ship with other items';
  }

  if (userSelections['step5']) {
    switch (userSelections['step5']) {
      case 'Hold Negatives': return 'Hold negs';
      case 'Pickup In-Store': return 'Pickup in-store';
      case 'Destroy / Bin my Negatives': return 'Bin negs';
    }
  }

  return '';
}

/**
 * Updates the availability of shipping options in Step 5.
 * If the user has selected to receive prints, options to hold or bin
 * negatives are disabled, as the negatives must be sent with the prints.
 */
function updateShippingOptions() {
  console.log("Updating shipping options based on print selection...");
  const step5Element = document.getElementById('step5');
  if (!step5Element) return;

  const step5Buttons = step5Element.querySelectorAll('button');
  const wantsPrints = userSelections['step4'] === 'Yes';

  step5Buttons.forEach(button => {
    const buttonText = button.textContent.trim();
    let isDisabled = false;

    // If user wants prints, disable "Hold" and "Bin" options.
    if (wantsPrints) {
      if (buttonText.includes('Hold Negatives') || buttonText.includes('Destroy / Bin')) {
        isDisabled = true;
      }
    }

    // Apply or remove the disabled state and corresponding styles
    button.disabled = isDisabled;
    if (isDisabled) {
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.classList.add('disabled-option');
    } else {
      button.style.opacity = '1';
      button.style.cursor = 'pointer';
      button.classList.remove('disabled-option');
    }
  });
}
